export default "__VITE_ASSET__d7cbd283__"